// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d02e22e5","453":"ae7ce9de"}[chunkId] + ".chunk.js";
};